import React, { useEffect, useState } from "react";
import { Box, CircularProgress, MenuItem, TextField, Typography } from "@mui/material";
import {
  getCPOOperationStatus,
  getOperationProcessList,
  updateCPOOperationStatus,
} from "../../api/operationProcess";
import OperationProcessStepper from "../OperationProcess/OperationProcessStepper";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

export default function CPOOperationStatusModal({ props }) {
  const { id: cpoId, companyId, onSubmit } = props;
  const { openSnack } = useSnack();
  const [loading, setLoading] = useState(true);
  const [processes, setProcesses] = useState([]);
  const [selectedProcessId, setSelectedProcessId] = useState("");
  const [currentStepId, setCurrentStepId] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [processesRes, statusRes] = await Promise.all([
          getOperationProcessList({ companyId }),
          getCPOOperationStatus(cpoId).catch((e) => {
            if (e?.response?.status === 404) return { data: null };
            throw e;
          }),
        ]);
        setProcesses(processesRes.data ?? []);

        const status = statusRes.data;
        if (status) {
          setSelectedProcessId(status.processId);
          setCurrentStepId(status.currentStepId);
        }
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [cpoId, companyId]);

  const selectedProcess = processes.find((p) => p.id === selectedProcessId);
  const steps = selectedProcess?.steps ?? [];

  const handleProcessChange = (event) => {
    setSelectedProcessId(Number(event.target.value));
    setCurrentStepId(null);
  };

  const handleSelectStep = async (stepId) => {
    if (!selectedProcessId) return;
    setCurrentStepId(stepId);
    setSaving(true);
    try {
      await updateCPOOperationStatus(cpoId, {
        processId: selectedProcessId,
        currentStepId: stepId,
      });
      openSnack("Estatus de operación actualizado con éxito", "success");
      onSubmit?.();
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 1 }}>
      <TextField
        select
        label="Proceso de operación"
        value={selectedProcessId}
        onChange={handleProcessChange}
        fullWidth
        disabled={saving}
        sx={{ mb: 2 }}
      >
        {processes.map((p) => (
          <MenuItem key={p.id} value={p.id}>
            {p.name}
          </MenuItem>
        ))}
      </TextField>

      {selectedProcess ? (
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Selecciona el paso en el que se encuentra actualmente la orden.
          </Typography>
          <OperationProcessStepper
            mode="select"
            steps={steps}
            activeStepId={currentStepId}
            onSelectStep={handleSelectStep}
          />
        </>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Selecciona un proceso para ver sus pasos.
        </Typography>
      )}
    </Box>
  );
}
